import React, { useEffect, useState, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "../../assets/css/mainMenu.css";
import "../../assets/css/dashboard.css";

import icon1 from "../../assets/icons/Component2.svg";
import logoM from "../../assets/icons/logo-m.svg";
import navLogo from "../../assets/Navlogo.svg";

import profileIcon from "../../assets/icons/fi_1946429.svg";
import arrowDown from "../../assets/icons/ArrowDown.svg";
import homeIcon from "../../assets/icons/home-icon.svg";
import wrenchIcon from "../../assets/icons/wrench1.svg";
import templatesIcon from "../../assets/icons/fi_1828824.svg";
import assetsIcon from "../../assets/icons/fi_3388671.svg";
import modelsIcon from "../../assets/icons/fi_3199725.svg";
import myAssetsIcon from "../../assets/icons/fi_621995.svg";
import reviewIcon from "../../assets/icons/fi_2326145.svg";

import arrowLineRight from "../../assets/icons/ArrowLineRight.svg";

import adjustIcon from "../../assets/icons/adjust(1)1.svg";
import layoutIcon from "../../assets/icons/layout-1.svg";

import agendaIcon from "../../assets/icons/agenda1.svg";
import packageIcon from "../../assets/icons/package1.svg";
import blockIcon from "../../assets/icons/block1.svg";
import categoriesIcon from "../../assets/icons/categories(1)1.svg";

import flag1 from "../../assets/icons/flag1.svg";

import setting from "../../assets/icons/setting(2)1.svg";
import logoutIcon from "../../assets/icons/logout-1.svg";
import close from "../../assets/icons/close.svg";
import recyclebin from "../../assets/icons/recycle-bin2.svg";
import { useDispatch, useSelector } from "react-redux";
import { fetchMenuItems } from "../../Redux/Menu/MenuSlice";
import { removeToken } from "../../AuthMiddleware/TokenService";
import { clearUser, setNotificationCount } from "../../Redux/User/UserSlice";
import { clearToken } from "../../Redux/Auth/TokenSlice";
import fetchWrapper from "../../AuthMiddleware/FetchWrapper";
import { hasPermission } from "../../Services/authUtils";
import bellIcon from "../../assets/icons/bellIcon.svg";




const NavBar = () => {
	// const user = useSelector((state) => state.user.user);
	const [jsonData1, setJsonData] = useState(null);

	const dispatch = useDispatch();
	// const [configItems, setConfigItems] = useState([]);
	const [templateItems, setTemplateItems] = useState([]);
	const [openDropdown, setOpenDropdown] = useState(null);
	const [openSubmenu, setOpenSubmenu] = useState(null);
	// const [profileName, setProfileName] = useState("");
	const [logoutModal, setLogoutModal] = useState(false);

	const navigate = useNavigate();
	const { items } = useSelector((state) => state.menu);
	const [lineage_id, setLineage_id] = useState("");
	const location = useLocation();
	const dropdownRef = useRef(null);
	const notificationCount = useSelector(
		(state) => state.user.notificationCount
	);
	const logoutAction = async () => {
		// Retrieve the token fromsessionStorage
		const token = sessionStorage.getItem("jwt_token");

		removeToken();
		sessionStorage.removeItem("jwt_token");
		sessionStorage.removeItem("email");
		sessionStorage.removeItem("username");
		sessionStorage.removeItem("user");
		dispatch(clearUser()); // Clear user state in Redux
		dispatch(clearToken());

		try {
			const response = await fetch(
				`${process.env.REACT_APP_BASE_API_URL1}/api/v1/logout`,
				{
					method: "POST",
					headers: {
						"Content-Type": "application/json",
						Authorization: `Bearer ${token}`, // Include the token in the headers
					},
				}
			);

			if (response.ok) {
			} else {
			}
		} catch (error) { }

		// Clear token state in Redux
		navigate("/auth/login"); // Navigate to login page after logout
	};
	const getNotificationCount = async () => {
		const token = sessionStorage.getItem("jwt_token");
		try {
			const response = await fetch(
				`${process.env.REACT_APP_BASE_API_URL1}/api/v1/notification/countUnreadNotifications`,
				{
					method: "POST",
					headers: {
						"Content-Type": "application/json",
						Authorization: `Bearer ${token}`,
					},
				}
			);

			if (!response.ok) throw new Error("Failed to fetch notification count");

			const result = await response.json(); // parse JSON
			// result = { message: "...", data: 2 }
			dispatch(setNotificationCount(result.data)); // set the unread count in Redux
		} catch (error) {
			console.error(
				"Failed to fetch notification count:",
				error.message || error
			);
		}
	};

	const handleDQRedirect = async () => {
		try {
			const response = await fetchWrapper(
				`${process.env.REACT_APP_BASE_API_URL1}/api/v1/user/generate-dq-token`,
				{ method: "POST", body: JSON.stringify({}) },
				navigate
			);
			if (response?.redirectUrl) {
				console.log("tokennnnnnnnnnn", response?.redirectUrl)
				window.open(response.redirectUrl, "_blank");
			}
		} catch (error) {
			console.error("Error generating DQ redirect URL:", error);
		}
	};


	useEffect(() => {
		getNotificationCount();
		try {
			const userdataSessionStorage = sessionStorage.getItem("user");

			if (userdataSessionStorage) {
				const parsedData = JSON.parse(userdataSessionStorage);
				setJsonData(parsedData);
			}
		} catch (error) {
			console.error("Error parsing JSON data from sessionStorage:", error);
		}
	}, [location.pathname]);

	const importIcon = async (iconName) => {
		try {
			const icon = await import(`../../assets/icons/${iconName}.svg`);
			return icon.default;
		} catch (error) {
			console.error(`Failed to import icon: ${iconName}`, error);
			return adjustIcon; // Default icon in case of import failure
		}
	};

	const fetchTemplateMenuItems = async () => {
		try {
			const data = await fetchWrapper(
				`${process.env.REACT_APP_BASE_API_URL1}/api/v1/template-type/getall`,
				{
					method: "POST",
					body: JSON.stringify({}),
				}
			);

			if (data.length > 0) {
				const firstItemId = data[0]._id;
				setLineage_id(firstItemId);

				const items = await Promise.all(
					data.map(async (item) => ({
						title: item.template_type_name,
						icon: await importIcon(item.icon),
						link: `/template_types/${item._id}`,
					}))
				);

				setTemplateItems(items);
			} else {
				console.error("No template items found.");
			}
		} catch (error) {
			console.error("Failed to fetch template menu items", error);
		}
	};

	useEffect(() => {
		// {
		//   if (
		//     hasPermission(["templates.view"]) ||
		//     hasPermission(["myAssets.view"]) ||
		//     hasPermission(["parameters.view"]) ||
		//     hasPermission(["masters.view"]) ||
		//     hasPermission(["assetGroup.view"]) ||
		//     hasPermission(["assets.view"])
		//   ) {
		//     fetchTemplateMenuItems();
		//   }
		// }
		fetchTemplateMenuItems();
		const handleScroll = () => {
			const navbar = document.getElementById("navbar");
			if (window.scrollY > 0) {
				navbar.classList.add("fixed");
			} else {
				navbar.classList.remove("fixed");
			}
		};

		const handleClickOutside = (event) => {
			if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
				setOpenDropdown(null);
				setOpenSubmenu(null);
			}
		};

		window.addEventListener("scroll", handleScroll);
		document.addEventListener("mousedown", handleClickOutside);

		return () => {
			window.removeEventListener("scroll", handleScroll);
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, []);

	useEffect(() => {
		dispatch(fetchMenuItems());
	}, [dispatch]);
	const handleDropdownToggle = (dropdown) => {
		setOpenDropdown(openDropdown === dropdown ? null : dropdown);
	};

	const handleSubmenuToggle = (submenu) => {
		setOpenSubmenu(openSubmenu === submenu ? null : submenu);
	};

	return (
		<>
			<div className="nav-container" ref={dropdownRef}>
				<div className="d-flex justify-content-between align-content-center flex-wrap navbar-1">
					<div className="pl-60 d-flex">
						<img
							src={icon1}
							style={{ marginRight: "12px" }}
							className="menu-icon"
							alt="Icon1"
						/>
						<div className="logo-m">
							<img src={logoM} width="46px" height="29.86px" alt="LogoM" />
						</div>
						<div className="search-div">
							<Link to="/">
								<img src={navLogo} alt="NavLogo" />
							</Link>
							{/* <input
                type="text"
                name="search"
                id="search"
                placeholder="Search"
              />
              <img className="search" src={searchIcon} alt="Search" /> */}
						</div>
					</div>
					<div className="d-flex justify-content-between align-content-center flex-wrap">
						<button
							onClick={handleDQRedirect}
							className="me-2"
							style={{
								background: "#dc3545",
								border: "none",
								borderRadius: "6px",
								padding: "8px 16px",
								color: "white",
								fontWeight: "600",
								fontSize: "14px",
								cursor: "pointer",
								transition: "all 0.3s ease",
								boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
							}}
							onMouseEnter={(e) => e.target.style.background = "#c82333"}
							onMouseLeave={(e) => e.target.style.background = "#dc3545"}
							title="Data Quality"
						>
							DQ
						</button>
						<Link
							to="/notifications"
							className="bell-icon me-2"
							style={{ textDecoration: "none" }}
						>
							<img src={bellIcon} alt="Notifications" />
							{notificationCount > 0 && (
								<span className="notification-badge">{notificationCount}</span>
							)}
						</Link>
						{/* <img src={settingsIcon} className="settings" alt="Settings" /> */}
						<li className="nav-item dropdown profile-btn">
							<a
								className="nav-link d-flex gap-btwn"
								href="#"
								id="navbarDropdown"
								role="button"
								data-bs-toggle="dropdown"
								aria-expanded="false"
							>
								<img src={profileIcon} alt="Profile" />
								<span className="mble-hide">
									{jsonData1 && jsonData1.name ? jsonData1.name : "Guest"}
								</span>
								<img src={arrowDown} alt="ArrowDown" />
							</a>
							<ul
								className="dropdown-menu menu-list profile-ul"
								aria-labelledby="navbarDropdown"
							>
								<li>
									<Link
										className="dropdown-item d-flex justify-content-start gap-3"
										to="/profilesetting"
									>
										<img src={setting} alt="SettingIcon" />
										<p className="m-0">Profile Settings</p>
									</Link>
								</li>
								{/* <li>
                  <Link
                    className="dropdown-item d-flex justify-content-start gap-3"
                    to="/globalsettings"
                  >
                    <img src={globeIcon} alt="GlobeIcon" />
                    <p className="m-0">Global Settings</p>
                  </Link>
                </li> */}
								{/* <li>
                  <a
                    className="dropdown-item d-flex justify-content-start gap-3"
                    href="#"
                  >
                    <img src={operationalSettingsIcon} alt="SettingIcon3" />
                    <p className="m-0">Operational Settings</p>
                  </a>
                </li> */}
								<li>
									<Link
										className="dropdown-item d-flex justify-content-start gap-3"
										onClick={() => setLogoutModal(true)}
									>
										<img
											src={logoutIcon}
											alt="GlobeIcon"
											width="20px"
											height="20px"
										/>
										<p className="m-0"> Logout </p>
									</Link>
								</li>
							</ul>
						</li>
					</div>
				</div>

				<nav
					style={{
						zIndex: 20,
						// width: "80%",
						// marginLeft: "120px",
						// marginRight: "120px",
					}}
					id="navbar"
					className="navbar navbar-expand-lg navbar-light navbar-2"
				>
					<div className="container-fluid p-0">
						<div
							className="collapse navbar-collapse"
							id="navbarSupportedContent"
						>
							<ul
								// className="navbar-nav navbar w-100 mb-2 mb-lg-0 dropdown-text">
								className="navbar-nav w-100 mb-2 mb-lg-0"
								style={{
									display: "flex", // Use flexbox
									flexDirection: "row", // Align items horizontally
									// Adjust the gap between items
									padding: 0, // Remove default padding
									margin: 0,
									gap: "60px", // Remove default margin
								}}
							>
								<DropdownItem
									title="HOME"
									icon={homeIcon}
									items={[
										{ title: "Dashboard", icon: layoutIcon, link: "/" },
										// { title: "Analytics", icon: graph_1Icon },
									]}
									openDropdown={openDropdown}
									setOpenDropdown={handleDropdownToggle}
									dropdownId="home"
								/>
								{(hasPermission(["parameters.view"]) ||
									hasPermission(["roles.view"]) ||
									hasPermission(["users.view"]) ||
									hasPermission(["departments.view"]) ||
									hasPermission(["masters.view"]) ||
									hasPermission(["roleGroups.view"]) ||
									hasPermission(["permission.view"])) && (
										<DropdownItem
											title="CONFIGURE"
											icon={wrenchIcon}
											items={items}
											includeArrowLineRight={true}
											openDropdown={openDropdown}
											setOpenDropdown={handleDropdownToggle}
											dropdownId="configure"
											openSubmenu={openSubmenu}
											setOpenSubmenu={handleSubmenuToggle}
										/>
									)}
								{hasPermission(["templates.view"]) && (
									<DropdownItem
										title="TEMPLATES"
										icon={templatesIcon}
										items={templateItems}
										openDropdown={openDropdown}
										setOpenDropdown={handleDropdownToggle}
										dropdownId="templates"
									/>
								)}
								{hasPermission(["assets.view"]) && (
									<DropdownItem
										title="ASSETS"
										icon={assetsIcon}
										items={[
											{
												title: "Asset Class",
												icon: agendaIcon,
												link: "/asset_list",
											},
											{
												title: "Asset Attribute",
												icon: flag1,
												link: "asset_attribute",
											},
										]}
										openDropdown={openDropdown}
										setOpenDropdown={handleDropdownToggle}
										dropdownId="assets"
									/>
								)}
								{hasPermission(["models.view"]) && (
									<DropdownItem
										title="MODELS"
										icon={modelsIcon}
										items={[
											{
												title: "Model Class",
												icon: blockIcon,
												link: "/model_list",
											},
										]}
										openDropdown={openDropdown}
										setOpenDropdown={handleDropdownToggle}
										dropdownId="models"
									/>
								)}
								{/* {hasPermission(["myAssets.view"]) && ( */}
								{hasPermission(["myAssets.view"]) ||
									hasPermission(["assetGroup.view"]) ? (
									<DropdownItem
										title="MY ASSETS"
										icon={myAssetsIcon}
										items={[
											hasPermission(["myAssets.view"]) && {
												title: "All Assets",
												icon: categoriesIcon,
												link: "/all_assets",
											},
											hasPermission(["assetGroup.view"]) && {
												title: "Asset Group",
												icon: packageIcon,
												link: "/all_assets_group",
											},
										].filter(Boolean)} // Filter out undefined items
										openDropdown={openDropdown}
										setOpenDropdown={handleDropdownToggle}
										dropdownId="my-assets"
									/>
								) : null}
								{hasPermission(["myAssets.view"]) ||
									hasPermission(["assetGroup.view"]) ||
									hasPermission(["templates.view"]) ||
									hasPermission(["assets.view"]) ? (
									<DropdownItem
										title="REVIEW"
										icon={reviewIcon}
										items={[
											{
												title: "List of Assets",
												icon: agendaIcon,
												link: `list_of_assets/${lineage_id}`,
											},
											{
												title: "Usecase Footprint",
												icon: agendaIcon,
												link: `usecases`,
											},
											{
												title: "SPV Mapping",
												icon: agendaIcon,
												link: `spv_mapping`,
											},
											{
												title: "Asset Tag Mapping",
												icon: agendaIcon,
												link: `asset_tag_mapping`,
											}
										]}
										openDropdown={openDropdown}
										setOpenDropdown={handleDropdownToggle}
										dropdownId="review"
									/>
								) : null}
								{/* <DropdownItem
                  title="UTILITIES"
                  icon={utilitiesIcon}
                  items={[
                    { title: "Asset Taxonomy", icon: hierarchyIcon },
                    { title: "Tag Structure", icon: tagIcon },
                    { title: "Model Structure", icon: nodeIcon },
                  ]}
                  openDropdown={openDropdown}
                  setOpenDropdown={handleDropdownToggle}
                  dropdownId="utilities"
                /> */}
								{/* More list items go here */}
							</ul>
						</div>
					</div>
				</nav>
			</div>

			<div
				id="overlay"
				className={`modal fade ${logoutModal ? "show" : ""}`}
				tabIndex="-1"
				role="dialog"
				style={{
					zIndex: 30,
					display: logoutModal ? "block" : "none",
					transition: "width 2s",
				}}
			>
				<div>
					<div className="addunit-card Width 25%">
						<div className="addunit-header">
							<h4>Logout</h4>
							<button
								style={{ border: "none", backgroundColor: "inherit" }}
								type="button"
								className="close"
								onClick={() => setLogoutModal(false)}
							>
								<img src={close} width="28px" height="28px" alt="Close" />
							</button>
						</div>

						<div className="delete-unit" style={{ padding: "28px 100px" }}>
							<img
								src={recyclebin}
								width="48px"
								height="48px"
								alt="Recyclebin"
							/>
							<h4 className="delete-unit-h4">Logout</h4>
							<p className="delete-unit-text">
								Are you sure you want to Logout?
							</p>
						</div>

						<div className="addunit-card-footer justify-content-between">
							<button
								type="button"
								className="discard-btn"
								onClick={() => setLogoutModal(false)}
							>
								CANCEL
							</button>
							<button
								type="button"
								className="update-btn"
								onClick={logoutAction}
							>
								CONFIRM
							</button>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

const DropdownItem = ({
	title,
	icon,
	items,
	includeArrowLineRight,
	openDropdown,
	setOpenDropdown,
	dropdownId,
	openSubmenu,
	setOpenSubmenu,
}) => {
	return (
		<li
			className={`nav-item dropdown ${openDropdown === dropdownId ? "show" : ""
				}`}
		>
			<Link
				className="nav-link active"
				id={`navbarDropdown_${title}`}
				role="button"
				onClick={() => setOpenDropdown(dropdownId)}
			>
				<img src={icon} alt={title} className="mb-2" />
				<span>{title}</span>
				<img src={arrowDown} alt={`ArrowDown_${title}`} />
			</Link>
			<ul
				className={`dropdown-menu menu-list ${openDropdown === dropdownId ? "show" : ""
					}`}
				aria-labelledby={`navbarDropdown_${title}`}
			>
				{items.map((item, index) =>
					item.link ? (
						<li key={index} className="btn-group dropend d-flex">
							<Link
								className="dropdown-item d-flex justify-content-start gap-3"
								to={item.link}
								onClick={() => setOpenDropdown(null)}
							>
								<div className="d-flex gap-3">
									<img src={item.icon} alt={item.title} />
									<p className="m-0">{item.title}</p>
								</div>
							</Link>
						</li>
					) : item.onClick ? (
						<li key={index} className="btn-group dropend d-flex">
							<Link
								className="dropdown-item d-flex justify-content-start gap-3"
								onClick={() => {
									item.onClick();
									setOpenDropdown(null);
								}}
								style={{ cursor: 'pointer' }}
							>
								<div className="d-flex gap-3">
									<img src={item.icon} alt={item.title} />
									<p className="m-0">{item.title}</p>
								</div>
							</Link>
						</li>
					) : (
						<li
							key={index}
							className={`btn-group dropend d-flex ${openSubmenu === item.title ? "show" : ""
								}`}
						>
							<Link
								className="dropdown-item  d-flex justify-content-between "
								onClick={() => setOpenSubmenu(item.title)}
							>
								<div className="d-flex gap-3">
									<img src={item.icon} alt={item.title} />
									<p className="m-0">{item.title}</p>
								</div>
								{includeArrowLineRight && index < items.length && (
									<img src={arrowLineRight} alt={`ArrowLineRight_${index}`} />
								)}
							</Link>
							{item.subItems && (
								<ul
									className={`dropdown-menu submenu ${openSubmenu === item.title ? "show" : ""
										}`}
								>
									{item.subItems.map((subItem, subIndex) => (
										<li key={subIndex}>
											<Link
												className="dropdown-item d-flex justify-content-start gap-3"
												to={subItem.link}
												onClick={() => {
													setOpenDropdown(null);
													setOpenSubmenu(null);
												}}
											>
												<img src={arrowLineRight} alt="arrowLineRight" />
												<p className="m-0">{subItem.title}</p>
											</Link>
										</li>
									))}
								</ul>
							)}
						</li>
					)
				)}
			</ul>
		</li>
	);
};

export default NavBar;
